/****************************************************
 * Module Name:  App.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React from "react";
import AppStart from "./components/appStart";
import { CookiesProvider } from "react-cookie";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "./landing/Landing";

function App() {
  return (
    <BrowserRouter>
      <CookiesProvider>
        <Routes>
          <Route path="/app/*" element={<AppStart />} />
          <Route path="/*" element={<Landing />} />
        </Routes>
      </CookiesProvider>
    </BrowserRouter>
  );
}

export default App;
